'use client';

import React from 'react';
import { Avatar, Chip, Link } from '@heroui/react';
import { Typography } from '../../../../components';
import { AccountCellProps } from '../types';

const AccountCell: React.FC<AccountCellProps> = ({ bill }) => {
  const modelName = bill.model?.name || bill.model?.of_user_name || '';
  const modelUsername = bill.model?.of_user_name || '';
  const popularityPercent = bill.model?.overall_popularity_percent;

  return (
    <div className="flex items-start gap-3">
      <Avatar
        src={bill.model?.avatar}
        showFallback
        name={modelName?.slice(0, 1)}
        className="w-10 h-10 rounded-3 flex-shrink-0"
      />
      <div className="flex flex-col">
        <div className="flex items-center gap-2">
          <Typography variant="label2" className="text-[#11181C] capitalize font-semibold">
            {bill.model?.name}
          </Typography>
          {modelUsername && (
            <Link
              href={`https://onlyfans.com/${modelUsername}`}
              target="_blank"
              className="text-partner text-sm font-normal"
            >
              @{modelUsername}
            </Link>
          )}
        </div>

        {popularityPercent !== undefined && popularityPercent !== null && (
          <div className="flex flex-wrap gap-2 mt-1">
            <Chip
              size="sm"
              variant="flat"
              classNames={{
                base: 'bg-warning/20',
                content: 'text-warning',
              }}
            >
              {popularityPercent.toFixed(1)}%
            </Chip>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountCell;
